import './mobile-menu.scss'

/**
 * Mobile Menu Toggle Functionality
 * Handles sub-menu toggling for menu items with children
 */
document.addEventListener( 'DOMContentLoaded', function() {
    
    const mobileMenu = document.getElementById( 'mobile-menu' );
    const hamburger = document.querySelector( '.js-hamburger' );
    const body = document.body;
    let lastFocusedElement = null;

    if ( ! mobileMenu || ! hamburger ) {
        return;
    }

    const isMenuOpen = () => body.classList.contains( '-showMobileMenu' );

    const openMenu = () => {
        if ( isMenuOpen() ) {
            return;
        }
        lastFocusedElement = document.activeElement;
        // Compensate for scrollbar disappearance to avoid layout shift
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if ( scrollbarWidth > 0 ) {
            body.style.setProperty( '--scrollbar-gap', scrollbarWidth + 'px' );
        }
        body.classList.add( '-showMobileMenu' );
        hamburger.setAttribute( 'aria-expanded', 'true' );
        mobileMenu.setAttribute( 'aria-hidden', 'false' );
        // Move focus into the dialog for accessibility
        mobileMenu.focus();
    };

    const closeMenu = () => {
        if ( ! isMenuOpen() ) {
            return;
        }
        body.classList.remove( '-showMobileMenu' );
        body.style.removeProperty( '--scrollbar-gap' );
        hamburger.setAttribute( 'aria-expanded', 'false' );
        mobileMenu.setAttribute( 'aria-hidden', 'true' );
        // Restore focus to the hamburger button
        if ( lastFocusedElement && typeof lastFocusedElement.focus === 'function' ) {
            lastFocusedElement.focus();
        } else {
            hamburger.focus();
        }
    };

    const toggleMenu = () => {
        if ( isMenuOpen() ) {
            closeMenu();
        } else {
            openMenu();
        }
    };

    // Toggle on hamburger click
    hamburger.addEventListener( 'click', function( event ) {
        event.preventDefault();
        toggleMenu();
    } );

    // Close on Escape key when menu is open
    document.addEventListener( 'keydown', function( event ) {
        if ( event.key === 'Escape' && isMenuOpen() ) {
            closeMenu();
        }
    } );

    // Handle menu item toggle clicks (submenu expand/collapse)
    mobileMenu.addEventListener( 'click', function( event ) {
        const clickedElement = event.target.closest( 'li.menu-item-has-children > a' );
        
        if ( ! clickedElement ) {
            return;
        }

        const parentLi = clickedElement.parentElement;
        const isExpanded = parentLi.classList.contains( '-expanded' );
        const hasBeenToggled = clickedElement.hasAttribute( 'data-toggled' );
        
        // If already expanded and clicked again, follow the link
        if ( isExpanded && hasBeenToggled ) {
            const href = clickedElement.getAttribute( 'href' );
            
            if ( href && href !== '#' ) {
                window.location.href = href;
            }
            return;
        }
        
        // Prevent default behavior for toggle action
        event.preventDefault();
        
        // Toggle the expanded state
        if ( isExpanded ) {
            // Collapse the sub-menu
            parentLi.classList.remove( '-expanded' );
            clickedElement.setAttribute( 'aria-expanded', 'false' );
            clickedElement.removeAttribute( 'data-toggled' );
        } else {
            // Expand the sub-menu
            parentLi.classList.add( '-expanded' );
            clickedElement.setAttribute( 'aria-expanded', 'true' );
            clickedElement.setAttribute( 'data-toggled', 'true' );
        }
    } );

    // Handle back button clicks in submenu wrappers
    mobileMenu.addEventListener( 'click', function( event ) {
        const backButton = event.target.closest( '.o-mobileMenu__backButton' );
        
        if ( ! backButton ) {
            return;
        }

        event.preventDefault();
        
        // Find the parent sub-menu-wrapper
        const subMenuWrapper = backButton.closest( '.sub-menu-wrapper' );
        
        if ( ! subMenuWrapper ) {
            return;
        }

        // Find the parent li.menu-item-has-children and remove -expanded class
        const parentLi = subMenuWrapper.closest( 'li.menu-item-has-children' );
        
        if ( parentLi ) {
            parentLi.classList.remove( '-expanded' );
            
            // Also update the aria-expanded attribute on the link
            const link = parentLi.querySelector( '> a' );
            if ( link ) {
                link.setAttribute( 'aria-expanded', 'false' );
                link.removeAttribute( 'data-toggled' );
            }
        }
    } );
    
} );